// extracted by css-extract-rspack-plugin
export default {"disabled":"AdminMailBody__disabled--u6GiH"};